/* ==========================================================================
   Feel · Article Page — Reading progress + TOC auto-build + scroll-spy +
                          Helpful widget + Share copy-link
   Source: _mockups/01_ALL_HTML_MOCKUPS/article.html
   Loaded by: sections/feel-article.liquid
   ========================================================================== */

(function () {
  'use strict';

  var FA = window.FA_ARTICLE_STRINGS || {};

  /* ===== CALLOUT CTA HREF FIX =====
     Imported articles hardcode https://feelawsm.com/products (bare, unlocalized,
     unstyled collections-list endpoint). Rewrite to the localized shop URL.
     Matches ONLY a bare /products path — never /products/{handle} PDPs. */
  if (FA.shop_url) {
    document.querySelectorAll('.article-product-callout a').forEach(function (a) {
      var path;
      try { path = new URL(a.getAttribute('href'), location.href).pathname; } catch (e) { return; }
      if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/products\/?$/i.test(path)) {
        a.href = FA.shop_url;
      }
    });
  }

  /* ===== READING PROGRESS BAR ===== */
  var progressBar = document.querySelector('[data-reading-progress] span');
  var articleBody = document.querySelector('[data-article-prose]');

  if (progressBar && articleBody) {
    function updateProgress() {
      var rect = articleBody.getBoundingClientRect();
      var articleTop    = rect.top + window.scrollY;
      var articleBottom = articleTop + articleBody.offsetHeight;
      var scrolled = window.scrollY + window.innerHeight;
      var pct = ((scrolled - articleTop) / (articleBottom - articleTop)) * 100;
      progressBar.style.width = Math.min(Math.max(pct, 0), 100) + '%';
    }
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  /* ===== READING PROGRESS — pin below real header height ===== */
  var progressWrap = document.querySelector('[data-reading-progress]');
  if (progressWrap) {
    function setProgressTop() {
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup) {
        progressWrap.style.top = headerGroup.offsetHeight + 'px';
      }
    }
    setProgressTop();
    window.addEventListener('resize', setProgressTop);
  }

  /* ===== TOC AUTO-BUILD ===== */
  var tocList = document.querySelector('[data-toc-list]');
  if (tocList && articleBody) {
    var headings = articleBody.querySelectorAll('h2');
    if (!headings.length) headings = articleBody.querySelectorAll('h3'); /* imported articles without h2 */
    if (headings.length > 0) {
      headings.forEach(function (h, i) {
        // Give each h2 an ID if missing
        if (!h.id) {
          h.id = 'section-' + (i + 1);
        }
        var li = document.createElement('li');
        var a  = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
      });

      // Open TOC details by default on desktop
      var tocDetails = document.querySelector('[data-toc-details]');
      if (tocDetails && window.innerWidth >= 1024) {
        tocDetails.open = true;
      }
    } else {
      // No headings — hide TOC entirely
      var tocWrap = document.querySelector('[data-toc-wrap]');
      if (tocWrap) { tocWrap.hidden = true; tocWrap.style.display = 'none'; }
    }
  }

  /* ===== SCROLL SPY — highlight active TOC link ===== */
  (function () {
    var tocLinks = document.querySelectorAll('[data-toc-list] a');
    if (!tocLinks.length) return;

    function getActive() {
      var scrollY = window.scrollY + 120; // offset for sticky header
      var active  = null;
      tocLinks.forEach(function (a) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (target && target.offsetTop <= scrollY) {
          active = a;
        }
      });
      return active;
    }

    function updateSpy() {
      var active = getActive();
      tocLinks.forEach(function (a) {
        a.classList.toggle('is-active', a === active);
      });
    }

    window.addEventListener('scroll', updateSpy, { passive: true });
    updateSpy();
  })();

  /* ===== HELPFUL WIDGET ===== */
  var helpfulBtns = document.querySelectorAll('[data-helpful-btn]');
  var helpfulThanks = document.querySelector('[data-helpful-thanks]');

  if (helpfulBtns.length) {
    helpfulBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        helpfulBtns.forEach(function (b) { b.dataset.active = 'false'; });
        btn.dataset.active = 'true';
        if (helpfulThanks) {
          helpfulThanks.hidden = false;
          helpfulThanks.textContent = btn.dataset.helpfulBtn === 'yes'
            ? 'Glad this helped.'
            : 'Thanks for the feedback — we\'ll keep improving.';
        }
      });
    });
  }

  /* ===== SHARE — COPY LINK ===== */
  var copyBtn = document.querySelector('[data-share-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          showCopied();
        });
      } else {
        // Fallback
        var ta = document.createElement('textarea');
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        showCopied();
      }

      function showCopied() {
        var orig = copyBtn.getAttribute('aria-label') || FA.copy_link || 'Copy link';
        copyBtn.setAttribute('aria-label', FA.copied || 'Copied!');
        setTimeout(function () {
          copyBtn.setAttribute('aria-label', orig);
        }, 2000);
      }
    });
  }

})();
